import React, { useEffect, useState } from 'react'
import moment from 'moment'
import pluralize from 'pluralize'
import { useSelector } from 'react-redux'
import { Switch, Route, Link, useHistory, useParams } from 'react-router-dom'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import { Drawer, Tabs, DatePicker, Dropdown, Menu, Typography } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, useListData, usePet, timeDiff, stringifyDate, patientName, server } from '../../modules'

import images from '../../images'

import Receive from '../reusable/receive'
import Modal from "../reusable/modal"
import Timeline from '../reusable/timeline'

import EntrySummary from './entrySummary'
import NewSupplier from './newSupplier'
import Attachment from './attachment'

const { TabPane } = Tabs
const { RangePicker } = DatePicker
const { Paragraph } = Typography

const MedHistory = ({ attachedTo, patient }) => {
    let group = 'Medication'
    const [ranges, setRanges] = useState()
    const [string, setString] = useState()

    const [includeOthers, toggleOthers] = useToggle()

    const { user } = useSelector(state => state.application)

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: billItems },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('billedItems', ranges ? {
        patient: patient?._id,
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        string,
        group,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { string, group, patient: patient?._id, attachedTo: includeOthers ? undefined : attachedTo?._id, }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <input
                        onChange={e => searchSent(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Search for item" />
                    <span>
                        <input
                            onChange={selectOthers}
                            checked={includeOthers}
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5" />
                        <span onClick={selectOthers} className="text-gray-500 cursor-pointer text-xs italic ml-2">Show medication from outside this period</span>
                    </span>
                </span>
                {
                    includeOthers &&
                    <RangePicker onChange={selectRange} />
                }
            </div>
            <div className="">
                <Receive
                    progress
                    loading={itLoading}
                    error={itError}>
                    {
                        billItems.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Item</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Quantity</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Sent By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            billItems.map((item, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((itPage - 1) * itLimit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.name} {item.quantity > 1 && ` (${item.instructions})`}</div>
                                                        <p className="text-gray-500 my-0 text-xs italic">Sent On {stringifyDate(item.date)}</p>
                                                        <p className={`text-${item.seen ? 'green' : 'yellow'}-500 mt-0 text-xs italic mb-0`}>{item.seen ? 'Seen' : 'Pending'}</p>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.quantity} {pluralize(item?.ref?.ref?.issuedIn ?? 'Units', item.quantity)}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.sentBy?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={() => null}>View</Menu.Item>
                                                                    {
                                                                        !item.seen && (item.sentBy._id === user?._id || user?.issuperuser) &&
                                                                        <>
                                                                            <Menu.Item onClick={() => null}>Edit</Menu.Item>
                                                                            <Menu.Item onClick={() => null}>Delete</Menu.Item>
                                                                        </>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No {pluralize(group.toLowerCase())} were found</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const History = ({ group, attachedTo, category, patient, name, path }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState()

    const [includeOthers, toggleOthers] = useToggle()

    const { user } = useSelector(state => state.application)

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: billItems },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('billedItems', ranges ? {
        patient: patient?._id,
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        string,
        group,
        category,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { string, group, attachedTo: includeOthers ? undefined : attachedTo?._id, category, patient: patient?._id }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <input
                        onChange={e => searchSent(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Search for item" />
                    <span>
                        <input
                            onChange={selectOthers}
                            checked={includeOthers}
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5" />
                        <span onClick={selectOthers} className="text-gray-500 cursor-pointer text-xs italic ml-2">Show {name ?? group?.toLowerCase() ?? 'history'} from outside this period</span>
                    </span>
                </span>
                {
                    includeOthers &&
                    <RangePicker onChange={selectRange} />
                }
            </div>
            <div className="">
                <Receive
                    progress
                    loading={itLoading}
                    error={itError}>
                    {
                        billItems.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Item</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Sent By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            billItems.map((item, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((itPage - 1) * itLimit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.name} {item.quantity > 1 && ` (x ${item.quantity})`}</div>
                                                        <p className="text-gray-500 my-0 text-xs italic">Sent On {stringifyDate(item.date)}</p>
                                                        <p className={`text-${item.seen ? 'green' : 'yellow'}-500 mt-0 text-xs italic mb-0`}>{item.seen ? `Seen by ${item?.seenBy?.name}` : 'Pending'}</p>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.sentBy?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Link to={`${path}/patients/${patient?._id}/${item._id}`} >
                                                            <button className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">{name === 'issued items' ? `No requests were made for ${patientName(patient?.name)}` : `${patientName(patient?.name)} wasn't sent for any ${group?.toLowerCase() ?? category?.toLowerCase() ?? 'items'}`}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Vitals = ({ patient, attachedTo, path }) => {
    const [ranges, setRanges] = useState()

    const [includeOthers, toggleOthers] = useToggle()

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: allVitals = [] },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('vitalsHistory', ranges ? {
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        patient: patient?._id,
        taken: true,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { attachedTo: includeOthers ? undefined : attachedTo?._id, taken: true, patient: patient?._id }, { notify: true }, 'vitals')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    const findVitals = (vtls, name) => {
        let field = vtls?.fields?.find(fld => fld?.name === name)
        let template = vtls?.item?.fields.find(fld => fld?.name === name)

        if (field)
            return { field, template }

        return null
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <input
                        onChange={selectOthers}
                        checked={includeOthers}
                        type="checkbox"
                        className="form-checkbox cursor-pointer h-5 w-5" />
                    <span onClick={selectOthers} className="text-gray-500 cursor-pointer text-xs italic ml-2">Show vitals from outside this period</span>
                </span>
                {
                    includeOthers &&
                    <RangePicker onChange={selectRange} />
                }
            </div>
            <div className="">
                <Receive
                    progress
                    loading={itLoading}
                    error={itError}>
                    {
                        allVitals.length > 0 ?
                            allVitals.map(vitals =>
                                <div className="shadow-lg rounded-sm border mb-3 border-gray-200 px-4 pt-4 pb-1">
                                    <span className="flex justify-between items-center">
                                        <div className="flex mb-2">
                                            <div className="mr-2 text-center p-2">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Weight') ? `${findVitals(vitals, 'Weight').field.value[0]} ${findVitals(vitals, 'Weight')?.template?.unit}` : '_'}</p>
                                                <p className="font-light text-xs mb-0">Weight</p>
                                            </div>
                                            <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Height') ? `${findVitals(vitals, 'Height').field.value[0]} ${findVitals(vitals, 'Height')?.template?.unit}` : '_'}</p>
                                                <p className="font-light text-xs mb-0">Height</p>
                                            </div>
                                            {
                                                findVitals(vitals, 'Height') && findVitals(vitals, 'Weight') ?
                                                <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                    <p className="font-semibold text-xl mb-1">{ (findVitals(vitals, 'Weight').field.value[0] / Math.pow((findVitals(vitals, 'Height').field.value[0] / 100), 2)).toFixed(2) }</p>
                                                    <p className="font-light text-xs mb-0">BMI</p>
                                                </div>
                                                : null
                                            }
                                            <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Temperature') ? `${findVitals(vitals, 'Temperature').field.value[0]} ${findVitals(vitals, 'Temperature')?.template?.unit}` : '_'}</p>
                                                <p className="font-light text-xs mb-0">Temperature</p>
                                            </div>
                                            <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Blood Pressure (Systolic)') ? `${findVitals(vitals, 'Blood Pressure (Systolic)').field.value[0]}` : '_'} / {findVitals(vitals, 'Blood Pressure (Diastolic)') ? `${findVitals(vitals, 'Blood Pressure (Diastolic)').field.value[0]}` : '_'} mmHg</p>
                                                <p className="font-light text-xs mb-0">Blood Pressure</p>
                                            </div>
                                            <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Pulse Rate') ? `${findVitals(vitals, 'Pulse Rate').field.value[0]} ${findVitals(vitals, 'Pulse Rate')?.template?.unit ?? ''}` : '_'}</p>
                                                <p className="font-light text-xs mb-0">Pulse</p>
                                            </div>
                                            <div className="mr-2 text-center border-l-2 p-2 border-gray-200">
                                                <p className="font-semibold text-xl mb-1">{findVitals(vitals, 'Oxygen') ? `${findVitals(vitals, 'Oxygen').field.value[0]} ${findVitals(vitals, 'Oxygen')?.template?.unit ?? ''}` : '_'}</p>
                                                <p className="font-light text-xs mb-0">Oxygen</p>
                                            </div>
                                        </div>
                                        {/* <Link to={`/app/admissions/${entry}/vitals/2`}> */}
                                        <button className="flex self-start btn mb-2 py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View</button>
                                        {/* </Link> */}
                                    </span>
                                    <div className="flex justify-between border-t-2 mb-2 border-gray-200 w-full pt-2">
                                        <p className="font-semibold italic text-xs mb-1">Taken by {vitals.filledBy.name}</p>
                                        <p className="font-light text-xs mb-0">{stringifyDate(vitals.filledOn)}</p>
                                    </div>
                                </div>
                            )
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No vitals were taken for {patientName(patient?.name)}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Schemes = ({ authorized, patient }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')

    const [
        { loading, error, fetch },
        { list: schemes = [] },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('schemesByPatient', { id: patient?._id, string }, { notify: true }, 'schemes')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    return (
        <>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        schemes.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Scheme</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Date</div>
                                            </th>
                                            {
                                                authorized &&
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            }
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            schemes.map((scheme, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{scheme?.scheme?.name} {scheme?.main && '(Main)'}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">Recorded on {stringifyDate(scheme.date)}</div>
                                                    </td>
                                                    {
                                                        authorized &&
                                                        <td className="p-2 text-center">
                                                            {
                                                                scheme?.scheme?.name !== 'Cash' &&
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            {/* <Menu.Item onClick={() => viewPlan(plan, key)}>Edit Plan</Menu.Item>
                                                                            <Menu.Item onClick={() => removePlan(key)}>Remove Plan</Menu.Item> */}
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            }
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No schemes were recorded for {patientName(patient?.name)}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Attachments = ({ authorized, patient, path }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')
    const [attch, setAttch] = useState()

    const [view, toggle] = useToggle()

    const [
        { loading, error, fetch },
        { list: attachments = [] },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('patientAttachments', ranges ? { 
        id: patient?._id, 
        string,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { id: patient?._id, string }, { notify: true }, 'attachments')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const searchDocs = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const viewAttachment = attch => {
        setAttch(attch)
        toggle()
    }

    const deleteAttachment = attch => {

    }

    return (
        <>
            { 
                view &&
                <Attachment
                    attachment={ attch }
                    toggle={ toggle }
                    visible={ view } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <input
                        onChange={e => searchDocs(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Search for item" />
                </span>
                <RangePicker onChange={selectRange} />
            </div>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        attachments.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Title</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Uploaded By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Uploaded On</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            attachments.map((attachment, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{attachment?.title}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{attachment?.uploadedBy?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{stringifyDate(attachment.uploadedOn)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={ () => viewAttachment(attachment) }>View Attachment</Menu.Item>
                                                                    { authorized && <Menu.Item onClick={() => deleteAttachment(attachment)}>Delete Attachment</Menu.Item> }
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No atatchments were uploaded for {patientName(patient?.name)}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Documents = ({ authorized, patient, path }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')

    const [
        { loading, error, fetch: fetchDocuments },
        { list: documents = [] },
        { page, limit, navigate, Paginate }
    ] = useListData('documents', ranges ? {
        // name: "Referral Form",
        patient: patient?._id,
        seen: true,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { seen: true, patient: patient?._id }, { notify: true })

    const refresh = () => {
        navigate(1)
        fetchDocuments()
    }

    const searchDocs = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <input
                        onChange={e => searchDocs(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Search for item" />
                </span>
                <RangePicker onChange={selectRange} />
            </div>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        documents.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Document Type</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Created By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Created On</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            documents.map((doc, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{doc?.item?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{doc?.filledBy?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{stringifyDate(doc?.filledOn)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Link to={`${path}/patients/${patient?._id}/${doc._id}`} ><Menu.Item>View</Menu.Item></Link>
                                                                    <a target="_blank" href={ `${server}/entry/${doc?._id}/print` }><Menu.Item>Print</Menu.Item></a>
                                                                    { authorized && <Menu.Item>Delete</Menu.Item> }
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No documents were created for {patientName(patient?.name)}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Patient = ({ attachedTo, source, reload = () => null }) => {
    const [patient, setPatient] = useState()
    const [field, setField] = useState()
    const [string, setString] = useState('')
    const [val, setVal] = useState()
    const [country, setCountry] = useState()
    const [supplier, setSupplier] = useState()
    const [countries, setCountries] = useState([])
    const [regions, setRegions] = useState([])

    const [visible, toggleVisible] = useToggle(true)

    const { user } = useSelector(state => state.application)

    const history = useHistory()
    const { id, pat } = useParams()

    const authorized = (user?.issuperuser || user.stations?.some(st => (st.name === 'cashier' || st.name === 'records') && (st.permissions.includes('edit-items') || st.permissions.includes('*'))))

    usePet('countries', null, { notify: true, callback: ({ data }) => setCountries(data) })

    const [{ loading: rLoading }, fetchRegions] = usePet('regions', { name: patient?.country }, { manual: true, notify: true, callback: ({ data }) => setRegions(data) })

    const [{ loading: pLoading, error: pError }, getDetails] = usePet('patient', { id: pat ?? id }, {
        notify: true, callback: ({ data }) => {
            setPatient(data)
            setCountry(data?.country)
            setSupplier(data?.supplier ? { label: data?.supplier?.name, value: data?.supplier?._id } : null)
            setTimeout(fetchRegions, 300)
        }
    })

    const [
        { loading: supLoading, fetch: fetchSuppliers },
        { list: suppliers = [] }
    ] = useListData('suppliers', { string, type: 'Marketer' }, { notify: true, manual: true })

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 100)
    }

    const onComplete = (_, notif, ops) => {
        reload()
        getDetails()
        setField()
        setVal()

        notif('Changes have been saved.', ops('success'))
    }

    const [{ loading }, editPatient] = usePet('editPatientDetails', {
        id: patient?._id,
        field,
        val
    }, { notify: true, load: { msg: 'Saving changes...' }, callback: onComplete, manual: true })

    const editDetails = (fld, vl) => {
        if (patient[fld] !== vl) {
            setField(fld)
            setVal(vl)
            editPatient()
        }
    }

    const searchSuppliers = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchSuppliers()
        }
    }

    const edit = fld => authorized ? { onChange: val => editDetails(fld, val) } : null

    const changeCountry = val => {
        setCountry(val?.value)
        editDetails('country', val?.value)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="50%">
            <Receive
                progress
                loading={pLoading}
                error={pError}>
                {
                    patient ?
                        <>
                            <p className="font-extrabold text-3xl mb-0">Patient's Details</p>
                            <div className="flex items-center px-2 py-4">
                                <div className="w-28 h-28 mb-2 self-center flex items-center rounded-full justify-center overflow-hidden">
                                    <img className="h-24 w-24 mx-auto" src={images[`${patient?.gender?.toLowerCase()}_alt`] ?? images.male_alt} />
                                </div>
                                <div>
                                    <div className="flex flex-col leading-none pl-4">
                                        <p className="text-2xl font-bold mb-0">{patient?.name}</p>
                                        <p className="text-sm my-1 font-light text-gray-700">
                                            {
                                                timeDiff(patient.dob) < 0 ?
                                                    timeDiff(patient.dob, 'months') < 0 ?
                                                        timeDiff(patient.dob, 'weeks') < 0 ?
                                                            timeDiff(patient.dob, 'days') < 0 ?
                                                                timeDiff(patient.dob, 'hours')
                                                                : timeDiff(patient.dob, 'days')
                                                            : timeDiff(patient.dob, 'weeks')
                                                        : timeDiff(patient.dob, 'months')
                                                    : timeDiff(patient.dob)
                                            } Years Old (Born on {stringifyDate(patient.dob, true)})
                                        </p>
                                        <p className="text-gray-500 text-xs mt-0">{ patient.opNo && `Outpatient No: ${patient.opNo < 1000 ? ('00000' + patient.opNo).slice(-4) : patient.opNo} ` }{ patient.ipNo && `| Inpatient No: ${patient.ipNo} ` }{ patient.matIpNo && `| Maternity No: ${patient.matIpNo}` }</p>
                                    </div>
                                </div>
                            </div>
                            <Tabs defaultActiveKey="0">
                                <TabPane className="pl-2" key="0" tab="Details">
                                    <p className="text-gray-500 font-bold text-xs my-0">BASIC INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('name')}>{patient?.name ?? ''}</Paragraph>
                                            </div>
                                            <div className="w-full mb-3">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Date of Birth
                                                </label>
                                                {
                                                    authorized ?
                                                        <DatePicker allowClear={false} dateFormat="MM/DD/YYYY" value={moment(patient?.dob)} onChange={val => editDetails('dob', val)} />
                                                        : <Paragraph>{stringifyDate(patient.dob, true)}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Gender
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.gender, value: patient.gender }}
                                                            onChange={vl => editDetails('gender', vl.value)}
                                                            options={['Male', 'Female'].map(item => ({ label: item, value: item }))}
                                                            placeholder="Select Gender" />
                                                        : <Paragraph>{patient.gender}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">IDENTIFICATION INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Identification Type
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.documentType, value: patient.documentType }}
                                                            onChange={vl => editDetails('documentType', vl.value)}
                                                            options={['National ID', 'Millitary ID'].map(item => ({ label: item, value: item }))}
                                                            placeholder="Select ID Type" />
                                                        : <Paragraph>{patient.documentType}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Identification No.
                                                </label>
                                                <Paragraph editable={edit('identification')}>{patient?.identification ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Beneficiary CR ID
                                                </label>
                                                <Paragraph editable={edit('beneficiaryCrId')}>{patient?.beneficiaryCrId ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">CONTACT INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('phone')}>{patient?.phone ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Email
                                                </label>
                                                <Paragraph editable={edit('email')}>{patient?.email ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">RESIDENTIAL INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-2">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Country
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.country, value: patient.country }}
                                                            onChange={changeCountry}
                                                            options={countries.map(country => ({ label: country, value: country }))}
                                                            placeholder="Select Country" />
                                                        : <Paragraph>{patient.country}</Paragraph>
                                                }
                                            </div>
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Locality
                                                </label>
                                                <Paragraph editable={edit('locality')}>{patient?.locality ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Region
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.region, value: patient.region }}
                                                            onChange={vl => {
                                                                editDetails('region', vl.value)
                                                            }}
                                                            options={regions.map(region => ({ label: region, value: region }))}
                                                            placeholder="Select Region" />
                                                        : <Paragraph>{patient.region}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">IDENTIFICATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Outpatient No.
                                                </label>
                                                <Paragraph editable={edit('opNo')}>{patient?.opNo ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Inpatient No.
                                                </label>
                                                <Paragraph editable={edit('ipNo')}>{patient?.ipNo ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">NEXT OF KIN INFORMATION</p>
                                    <div className="grid md:grid-cols-3 pl-3 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('nokName')}>{patient?.nokName}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Relationship
                                                </label>
                                                <Paragraph editable={edit('nokRShip')}>{patient?.nokRShip}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('nokPhone')}>{patient?.nokPhone}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">BROUGHT BY</p>
                                    <div className="grid md:grid-cols-3 pl-3 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('broughtByName')}>{patient?.broughtByName}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Relationship
                                                </label>
                                                <Paragraph editable={edit('broughtByRShip')}>{patient?.broughtByRShip}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('broughtByPhone')}>{patient?.broughtByPhone}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (user?.issuperuser || user.stations?.some(st => st.name === 'marketing')) &&
                                        <>
                                            <p className="text-gray-500 font-bold text-xs my-0">MARKETING INFORMATION</p>
                                            <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                                <div className="w-full md:mb-2">
                                                    <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                        Marketer
                                                    </label>
                                                    <Creatable
                                                        onCreateOption={ () => history.push(`${source}/patients/${patient?._id}/addSupplier`) }
                                                        isLoading={supLoading}
                                                        loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                                        className="min-w-56 mr-4"
                                                        // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
                                                        onInputChange={searchSuppliers}
                                                        value={supplier}
                                                        onChange={setSupplier}
                                                        options={suppliers.map(supplier => ({ label: supplier.name, value: supplier._id }))}
                                                        placeholder="Search for Supplier" />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </TabPane>
                                <TabPane key="1" tab="Timeline">
                                    <Timeline
                                        patient={patient}
                                        entryPathBase={`${source}/patients/${patient?._id}`} />
                                </TabPane>
                                <TabPane key="2" tab="Schemes">
                                    <Schemes authorized={ authorized } patient={patient} />
                                </TabPane>
                                <TabPane key="3" tab="Attachments">
                                    <Attachments 
                                        path={source}
                                        patient={patient}
                                        authorized={ authorized } />
                                </TabPane>
                                <TabPane key="4" tab="Documents">
                                    <Documents 
                                        path={source}
                                        patient={patient}
                                        authorized={ authorized } />
                                </TabPane>
                                <TabPane key="5" tab="Vitals">
                                    <Vitals patient={patient} />
                                </TabPane>
                                <TabPane key="6" tab="Doctor">
                                    <History
                                        path={source}
                                        category="Doctor"
                                        attachedTo={attachedTo}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="7" tab="Investigations" >
                                    <History
                                        path={source}
                                        group="Investigations"
                                        attachedTo={attachedTo}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="8" tab="Treatments">
                                    <History
                                        path={source}
                                        group="Treatment"
                                        attachedTo={attachedTo}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="9" tab="Medication">
                                    <MedHistory
                                        path={source}
                                        attachedTo={attachedTo}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="10" tab="Issued Items">
                                    <History
                                        path={source}
                                        name="issued items"
                                        group="Non-Medical Billed Items"
                                        attachedTo={attachedTo}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="11" tab="Surgery">
                                    <History
                                        path={source}
                                        category="Theatre Operations"
                                        name="surgeries"
                                        patient={patient} />
                                </TabPane>
                            </Tabs>
                        </>
                        : null
                }
            </Receive>
            <Switch>
                <Route path={`${source}/patients/:pt/addSupplier`}>
                    <NewSupplier
                        string={string}
                        onPerform={x => setSupplier({ label: x.name, value: x._id })}  />
                </Route>
                <Route path={`${source}/patients/:pt/:ref`}>
                    <EntrySummary path={`${source}/patients/${patient?._id}`} />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Patient
